import type { SchedulerItem } from "./slice";

const SCHEDULER_DAY_INDEXES = [0, 1, 2, 3, 4, 5, 6];

/**
 * Task type shown in Schedule Preview and sent on create/update.
 * Both surfaces read the draft type field.
 */
export function schedulerTaskType(
  draft: Partial<SchedulerItem> | undefined,
): string {
  return typeof draft?.type === "string" ? draft.type : "";
}

/**
 * Keep the selected weekday indexes. A full Sun-Sat selection stays
 * [0, 1, 2, 3, 4, 5, 6] and is not collapsed to an empty list.
 */
export function serializeSchedulerDays(days: number[] | undefined): number[] {
  if (!Array.isArray(days) || days.length === 0) {
    return [];
  }

  const selected = new Set<number>();
  for (const day of days) {
    if (SCHEDULER_DAY_INDEXES.includes(day)) {
      selected.add(day);
    }
  }

  return SCHEDULER_DAY_INDEXES.filter((day) => selected.has(day));
}

/**
 * Create and update body for the existing scheduler task API.
 */
export function buildSchedulerWriteBody(data: Partial<SchedulerItem>) {
  const scheduleType = data.schedule?.type;

  return {
    scheduleType,
    title: data.title,
    service: data.service,
    type: schedulerTaskType(data),
    days: serializeSchedulerDays(data.schedule?.days),
    intervalMinutes:
      data.schedule?.type === "interval" ? data.schedule.interval : undefined,
    specificTimes:
      data.schedule?.type === "specific" ? data.schedule.specific : undefined,
    isActive: data.isActive,
  };
}
